import React, { useState, useEffect } from "react";
import {
  withStyles,
  Button,
  Dialog,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
} from "@material-ui/core/";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import localizedStrings from "../../../../utils/localize";
import Backdrop from "../../../Backdrop";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;

  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
const Attendance = (props) => {
  const { open, onHandleClose } = props;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [modalData, setModalData] = useState([]);

  const dataFetchingStatus = useSelector(
    (state) => state.classData.dataFetchingStatus,
  );
  const rosterData = useSelector((state) => state.classData.classRoster);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    if (rosterData && rosterData?.data?.length > 0) {
      setModalData(rosterData.data);
    }
  }, [rosterData]);

  let tableData = "";
  tableData =
    modalData?.length > 0
      ? modalData
          ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((element, index) => (
            <StyledTableRow key={index}>
              <StyledTableCell>
                {element.ses_institutionstudentid}
              </StyledTableCell>
              <StyledTableCell>{element.ses_studentname}</StyledTableCell>
              <StyledTableCell>{element[
                    "ses_studentstatus@OData.Community.Display.V1.FormattedValue"
                  ]}</StyledTableCell>
              <StyledTableCell>
                {
                  element[
                    "ses_gradeoption@OData.Community.Display.V1.FormattedValue"
                  ]
                }
              </StyledTableCell>
              <StyledTableCell>
                {element.ses_sessionpercenttodate}
              </StyledTableCell>
              <StyledTableCell>{element.ses_sessiongrade1}</StyledTableCell>
              <StyledTableCell>{element.ses_gradereceived}</StyledTableCell>
              <StyledTableCell>{element.ses_creditsearned}</StyledTableCell>
              <StyledTableCell>
                {
                  element[
                    "ses_credittype@OData.Community.Display.V1.FormattedValue"
                  ]
                }
              </StyledTableCell>
            </StyledTableRow>
          ))
      : null;

  return (
    <div>
      <Dialog
        onClose={onHandleClose}
        aria-labelledby="Attendance-dialog-title"
        open={open}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle id="customized-dialog-title" onClose={props.handleClose}>
          {localizedStrings.students.classes.roster.classRoster}
        </DialogTitle>
        <DialogContent dividers>
          <Backdrop show={dataFetchingStatus} />
          <TableContainer
            component={Paper}
            style={{ minHeight: "40vh", marginBottom: "10px" }}
          >
            <Table aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>
                    {localizedStrings.students.classes.roster.studentId}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.students.classes.roster.studentName}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.students.classes.roster.status}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.students.classes.roster.gradeType}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.students.classes.roster.percentage}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.students.classes.roster.numericGrade}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.students.classes.roster.letterGrade}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.students.classes.roster.creditEarned}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.students.classes.roster.creditType}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>{tableData}</TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            style={{ textTransform: "capitalize" }}
            rowsPerPageOptions={[5, 10, 25, 100]}
            component="div"
            count={modalData?.length > 0 ? modalData?.length : 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={onHandleClose} color="primary">
            {localizedStrings.students.selectClasses.modalTable.close}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withRouter(Attendance);
